import React, { Component } from 'react';
import DataTables from './DataTables';
import { Link, Navigate } from 'react-router-dom';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import DoughNut from './Charts/DoughNut';
import BarChart from './Charts/BarChart';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import PolarChart from './Charts/PolarChart';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import StackedBar from './Charts/StackedBar';
import { RETAIL_STORE_HANDOVERS } from '../Utilities/AppData/Handovers/RetailStoreHandovers';
import { RETAIL_STORE_EVACUATIONS } from '../Utilities/AppData/Evacuations';
import { RETAIL_STORE_NONCONFORMITIES } from '../Utilities/AppData/Nonconformities/RetailStoreNonconformities';
import { RETAIL_STORE_INCIDENTS } from '../Utilities/AppData/Incidents/RetailStoreIncidents';
import { SAFTEY_STORE } from '../pages/SafetyRegister/SafetyRegisterData';
import LZString from 'lz-string';
import { RETAIL_TRAINING_STORE } from '../Utilities/AppData/Training/RetailTrainingStore';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';

class StoreDashboardRetail extends Component {
  constructor(props) {
    super(props);

    const config = JSON.parse(Config);

    const store = this.props.location.state;

    let stores = JSON.parse(localStorage.getItem('storeData')).sort((a, b) =>
      a.storeName > b.storeName ? 1 : -1
    );

    localStorage.removeItem('curStoreID');
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
    const menu = user['moduleAccess'];
    let userID = user['userId'];
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    let cities = JSON.parse(localStorage.getItem('CitiesForStores'));
    cities &&
      cities.cityInfos.sort((a, b) => (a.cityName > b.cityName ? 1 : -1));

    //alert(localStorage.getItem('currentCityForDashboardStore'));
    //alert(JSON.stringify(cities.cityInfos[0].cityId));
    // alert(JSON.stringify(store));
    //alert(JSON.stringify(store['storeId']));

    this.state = {
      title: 'Store Dashboard',
      stores,
      modalOpen: false,
      graph: false,

      message: '',
      apiInterface: config['api'],
      alerts: [],
      alertno: [],
      ytdCount: [],
      userID,
      user: menu,
      pageAllowed: false,
      cities,
      storeName:
        store && store['storeName']
          ? store['storeName']
          : localStorage.getItem('currentStoreForDashboardStoreName')
          ? localStorage.getItem('currentStoreForDashboardStoreName')
          : typeof stores !== 'undefined' && stores.length > 0
          ? stores[0].storeName
          : '',
      storeid:
        store && store['storeId']
          ? store['storeId']
          : localStorage.getItem('currentStoreForDashboardStore')
          ? localStorage.getItem('currentStoreForDashboardStore')
          : typeof stores !== 'undefined' && stores.length > 0
          ? stores[0].storeId
          : 0,
      search:
        store && store['storeId']
          ? store['storeId']
          : localStorage.getItem('currentStoreForDashboardStore')
          ? localStorage.getItem('currentStoreForDashboardStore')
          : typeof stores !== 'undefined' && stores.length > 0
          ? stores[0].storeId
          : 0,
      proxyjson: [],
      proxyjson1: [],
      proxyjson2: [],
      proxyjson3: [],
      proxyjson4: [],
      proxyjson5: [],

      currentCity:
        store && store['currentCity']
          ? store['currentCity']
          : localStorage.getItem('cityForDashboardStore')
          ? localStorage.getItem('cityForDashboardStore')
          : '',
      proxyJsonMonthlyCheckList: [],
      proxyJsonWeeklyCheckList: [],
      loading: false,
      month: config['month'],
      currentMonth:
        store && store['month'] ? store['month'] : new Date().getMonth() + 1,
      currentyear:
        store && store['year'] ? store['year'] : new Date().getFullYear(),
      years: config['years'],
      multiSearch: '',
      tabIndex: store && store['tabIndex'] ? store['tabIndex'] : 3,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(
    index,
    month = this.state.currentMonth,
    year = this.state.currentyear,
    storeid = this.state.storeid
  ) {
    this.setState({
      activeTab: index,
      loading: true,
    });
    if (storeid) {
      if (index === 0) {
        RETAIL_STORE_EVACUATIONS(
          '/fetchStoreWiseEvacuationReport',
          storeid,
          year
        )
          .then((response) => {
            if (
              response.errorMessage === 'Token Expired' ||
              response.errorMessage === 'Invalid Token:::JWT expired' ||
              response.errorMessage ===
                'Your session has expired. Please login again.'
            ) {
              Cookie.remove('currentUser');
              Cookie.remove('stores');
              Cookie.remove('storesAll');
              Cookie.remove('warehouses');

              localStorage.clear();
              sessionStorage.clear();
              this.setState({
                loading: false,
                modalOpen: true,
                message:
                  'Your session has been expired and you will be redirected to the login page!!',
              });
              setTimeout(() => {
                return (window.location = '/');
              }, 4000);
            }
            this.setState({
              storeDashboard: true,
              proxyjson: response,
              loading: false,
            });
          })
          .catch(() => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      } else if (index === 1) {
        RETAIL_STORE_INCIDENTS(
          '/fetchStoreWiseIncidentReport',
          storeid,
          month,
          year
        )
          .then((response) => {
            this.setState({
              ytdCount: response.ytdCount,
              storeDashboard: true,
              alerts: response.stores,
              alertno: response.mic,
              proxyjson: response,
              loading: false,
            });
          })
          .catch(() => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      } else if (index === 2) {
        RETAIL_STORE_HANDOVERS(
          '/fetchHandoverStorewiseDashBoards',
          storeid,
          month,
          year
        )
          .then((response) => {
            this.setState({
              storeDashboard: true,
              proxyjson: response['proxyjson'],
              proxyJsonWeeklyCheckList: response['proxyJsonWeeklyCheckList'],
              proxyJsonMonthlyCheckList: response['proxyJsonMonthlyCheckList'],

              loading: false,
            });
          })
          .catch(() => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      } else if (index === 3) {
        RETAIL_STORE_NONCONFORMITIES(
          '/fetchStorewiseNonConfirmityDashboardRetail',
          storeid,
          month,
          year
        )
          .then((response) => {
            this.setState({
              storeDashboard: true,
              graph: true,
              proxyjson: response['proxyjson'],
              proxyJsonWeeklyCheckList: response['proxyJsonWeeklyCheckList'],

              loading: false,
            });
          })
          .catch(() => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      } else if (index === 4) {
        SAFTEY_STORE('/loadSafetyRegisterStorewiseDashboard', year, storeid)
          .then((response) => {
            this.setState({
              proxyjson4: response,
              loading: false,
            });
          })
          .catch(() => {
            this.setState({
              loading: false,
              modalOpen: false,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      } else if (index === 5) {
        RETAIL_TRAINING_STORE(
          '/fetchTrainingMonthWiseDashboardRetail',

          storeid,
          year
        )
          .then((response) => {
            this.setState({
              proxyjson5: response,
              loading: false,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
              modalOpen: false,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      }
    } else {
      this.setState({
        loading: false,
        modalOpen: false,
      });
    }
  }

  handleMonthChange = (e) => {
    this.setState({
      currentMonth: e.target.value,
    });
    this.handleSelect(
      this.state.activeTab,
      e.target.value,
      this.state.currentyear
    );
  };
  handleSearch = (e) => {
    var index = e.target.selectedIndex;

    this.setState({
      storeid: e.target.value,
      search: e.target.value,
      storeName: e.target[index].text,
    });
    localStorage.setItem('currentStoreForDashboardStore', e.target.value);
    localStorage.setItem(
      'currentStoreForDashboardStoreName',
      e.target[index].text
    );
    localStorage.setItem('cityForDashboardStore', this.state.currentCity);
    this.handleSelect(
      this.state.activeTab,
      this.state.currentMonth,
      this.state.currentyear,
      e.target.value
    );
  };

  handleYearChange = (e) => {
    this.setState({
      currentyear: e.target.value,
    });
    this.handleSelect(
      this.state.activeTab,
      this.state.currentMonth,
      e.target.value
    );
  };
  handleCityChange = (e) => {
    this.setState({
      currentCity: e.target.value,
    });

    ApiGateWay.Post(this.state.apiInterface + `/fetchStoreInfo`, {
      userId: this.state.userID,
      cityIds: e.target.value,
      appType: 'Web',
    })
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        console.log(JSON.stringify(this.state.stores));
        console.log(
          JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
        );
        if (response['storesInfos'][0]['storeType'] === 'Store') {
          this.setState({
            stores: response['storesInfos'][0]['storeLocationsInfos'],
          });
        } else {
          this.setState({
            stores: response['storesInfos'][1]['storeLocationsInfos'],
          });
        }
      })
      .catch(() => {
        this.setState({
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      });
  };

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? val.featureAccess
          ? val.featureAccess.map((child1, ind) =>
              child1.value == 1
                ? child1.featureName == 'Store Dashboard'
                  ? (pageAllow = true)
                  : ''
                : ''
            )
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });
      setTimeout(() => {
        this.handleSelect(this.state.tabIndex);
      }, 0);
      let store = this.props.location.state ? this.props.location.state : '';

      // if (
      //   store['storeId'] === undefined ||
      //   localStorage.getItem('cityForDashboardStore') !== null ||
      //   localStorage.getItem('cityForDashboardStore') !== undefined
      // ) {
      //   ApiGateWay.Post(this.state.apiInterface + `/fetchStoreInfo`, {
      //     userId: this.state.userID,
      //     cityIds: this.state.currentCity,
      //     appType: 'Web',
      //   })
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (
      //         response.errorMessage === 'Token Expired' ||
      //         response.errorMessage === 'Invalid Token:::JWT expired' ||
      //         response.errorMessage ===
      //           'Your session has expired. Please login again.'
      //       ) {
      //         Cookie.remove('currentUser');
      //         Cookie.remove('stores');
      //         Cookie.remove('storesAll');
      //         Cookie.remove('warehouses');

      //         localStorage.clear();
      //         sessionStorage.clear();
      //         this.setState({
      //           loading: false,
      //           modalOpen: true,
      //           message:
      //             'Your session has been expired and you will be redirected to the login page!!',
      //         });
      //         setTimeout(() => {
      //           return (window.location = '/');
      //         }, 4000);
      //       }

      //       console.log(JSON.stringify(this.state.stores));
      //       console.log(
      //         JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
      //       );

      //       if (response['storesInfos'][0]['storeType'] === 'Store') {
      //         this.setState({
      //           stores: response['storesInfos'][0]['storeLocationsInfos'],
      //           storeid:
      //             store && store['storeId']
      //               ? store['storeId']
      //               : localStorage.getItem('currentStoreForDashboardStore')
      //               ? localStorage.getItem('currentStoreForDashboardStore')
      //               : response['storesInfos'][0][
      //                   'storeLocationsInfos'
      //                 ].sort((a, b) => (a.storeName > b.storeName ? 1 : -1))[0]
      //                   .storeId,
      //           storeName:
      //             store && store['storeName']
      //               ? store['storeName']
      //               : localStorage.getItem('currentStoreForDashboardStoreName')
      //               ? localStorage.getItem('currentStoreForDashboardStoreName')
      //               : response['storesInfos'][0][
      //                   'storeLocationsInfos'
      //                 ].sort((a, b) => (a.storeName > b.storeName ? 1 : -1))[0]
      //                   .storeName,
      //         });
      //       } else {
      //         this.setState({
      //           stores: response['storesInfos'][1]['storeLocationsInfos'],
      //           storeid:
      //             store && store['storeId']
      //               ? store['storeId']
      //               : localStorage.getItem('currentStoreForDashboardStore')
      //               ? localStorage.getItem('currentStoreForDashboardStore')
      //               : response['storesInfos'][1][
      //                   'storeLocationsInfos'
      //                 ].sort((a, b) => (a.storeName > b.storeName ? 1 : -1))[0]
      //                   .storeId,
      //           storeName:
      //             store && store['storeName']
      //               ? store['storeName']
      //               : localStorage.getItem('currentStoreForDashboardStoreName')
      //               ? localStorage.getItem('currentStoreForDashboardStoreName')
      //               : response['storesInfos'][1][
      //                   'storeLocationsInfos'
      //                 ].sort((a, b) => (a.storeName > b.storeName ? 1 : -1))[0]
      //                   .storeName,
      //         });
      //       }
      //     })
      //     .catch(() => {
      //       this.setState({
      //         modalOpen: !this.state.modalOpen,
      //         message: 'Something went wrong please try again after sometime',
      //         loading: false,
      //       });
      //     });
      // }
    } else {
      this.setState({
        loading: true,
        pageAllowed: false,
      });
    }
  }
  render() {
    const {
      loading,
      currentMonth,
      years,
      month,
      cities,
      stores,
      currentCity,
      currentyear,
      pageAllowed,
      modalOpen,
    } = this.state;
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? val.featureAccess
              ? val.featureAccess.map((child1, ind) =>
                  child1.value == 1
                    ? child1.featureName == 'Store Dashboard'
                      ? (pageAllow = true)
                      : ''
                    : ''
                )
              : ''
            : ''
        )}
        {pageAllow === false ? (
          
          <Navigate to="/pageNotAllowed" state={{ id:'Store Dashboard' }} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={this.state.message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={'Store Dashboard - ' + this.state.storeName} />

          <Menu />

          <div className='content-wrapper'>
            <section className='content'>
              <div className='row alignClass'>
                <div className='col-md-2 col-lg-2 col-sm-2'>
                  <form style={{ background: 'none', padding: 'none' }}>
                    <div className='form-group'>
                      <select
                        className='form-control'
                        value={currentMonth}
                        onChange={this.handleMonthChange}
                      >
                        <option>Month</option>
                        {month.map((val, index) => (
                          <option key={index} value={index + 1}>
                            {val}
                          </option>
                        ))}
                      </select>
                    </div>
                  </form>
                  <br />
                  <br />
                </div>
                <div className='col-md-2 col-lg-2 col-sm-2'>
                  <form style={{ background: 'none', padding: 'none' }}>
                    <div className='form-group'>
                      <select
                        className='form-control '
                        value={currentyear}
                        onChange={this.handleYearChange}
                      >
                        <option>Year</option>
                        {years.map((val, index) => (
                          <option key={index} value={val}>
                            {val}
                          </option>
                        ))}
                      </select>
                    </div>
                  </form>
                </div>
                <div className='col-md-4 col-lg-4 col-sm-4 '>
                  <div className='row'>
                    <div className='col-md-6'>
                      <form style={{ background: 'none' }}>
                        <div className='form-group'>
                          <select
                            className='form-control '
                            value={currentCity}
                            onChange={this.handleCityChange}
                          >
                            <option value=''>All Cities</option>
                            {cities &&
                              cities.cityInfos
                                .sort((a, b) =>
                                  a.cityName > b.cityName ? 1 : -1
                                )
                                .map((val, index) => (
                                  <option key={val.cityId} value={val.cityId}>
                                    {val.cityName}
                                  </option>
                                ))}
                          </select>
                        </div>
                      </form>
                    </div>
                    <div className='col-md-6'>
                      <form style={{ background: 'none' }}>
                        <div className='form-group'>
                          <select
                            id='Select'
                            className='form-control'
                            value={this.state.storeid}
                            onChange={this.handleSearch}
                          >
                            <option>Select a Store</option>
                            {stores
                              ? stores
                                  .sort((a, b) =>
                                    a.storeName > b.storeName ? 1 : -1
                                  )
                                  .map((val) => (
                                    <option
                                      key={val.storeId}
                                      value={val.storeId}
                                    >
                                      {val.storeName}
                                    </option>
                                  ))
                              : null}
                          </select>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {loading ? (
                <Spinner />
              ) : (
                <div className='row'>
                  <div className='col-md-12 exportButton'>
                   
                    <Link to="/pdfExportStore" state={{ 
                       state: this.state,
                 }} >
                      <button
                        className='deca-btn-yellow'
                        style={{ marginBottom: '10px' }}
                      >
                        Download Report
                      </button>
                    </Link>
                  </div>
                  <div className='col-md-12'>
                    {/* Custom Tabs */}
                    <div className='nav-tabs-custom'>
                      <ul className='nav nav-tabs'>
                        <li
                          className={this.state.activeTab === 3 ? 'active' : ''}
                          onClick={() => this.handleSelect(3)}
                        >
                          <a href='#tab_4' data-toggle='tab'>
                            Non Conformities
                          </a>
                        </li>
                        <li
                          className={this.state.activeTab === 4 ? 'active' : ''}
                          onClick={() => this.handleSelect(4)}
                        >
                          <a href='#tab_5' data-toggle='tab'>
                            Compliance & Contracts
                          </a>
                        </li>
                        <li
                          className={this.state.activeTab === 2 ? 'active' : ''}
                          onClick={() => this.handleSelect(2)}
                        >
                          <a href='#tab_3' data-toggle='tab'>
                            Handovers
                          </a>
                        </li>

                        <li
                          className={this.state.activeTab === 5 ? 'active' : ''}
                          onClick={() => this.handleSelect(5)}
                        >
                          <a href='#tab_6' data-toggle='tab'>
                            Training
                          </a>
                        </li>
                        <li
                          className={this.state.activeTab === 1 ? 'active' : ''}
                          onClick={() => this.handleSelect(1)}
                        >
                          <a href='#tab_2' data-toggle='tab'>
                            Incidents
                          </a>
                        </li>
                        <li
                          className={this.state.activeTab === 0 ? 'active' : ''}
                          onClick={() => this.handleSelect(0)}
                        >
                          <a href='#tab_1' data-toggle='tab'>
                            Evacuations
                          </a>
                        </li>
                      </ul>

                      <div className='tab-content'>
                        {this.state.activeTab === 0 ? (
                          <div className='tab-pane active' id='tab_1'>
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  title='Evacuations'
                                  storeDashboard={true}
                                  data={this.state.proxyjson}
                                  name='StorewiseEvacuations'
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>

                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.activeTab === 2 ? (
                          <div
                            className={
                              this.state.activeTab === 2
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_3'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  title='Evacuations'
                                  storeDashboard={true}
                                  data={this.state.proxyjson}
                                  name='StorewiseEvacuations'
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8 close'>
                                <DataTables
                                  title='Handovers'
                                  storeDashboard={true}
                                  data={this.state.proxyjson}
                                  name='StorewiseHandovers'
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  title='Handovers'
                                  storeDashboard={true}
                                  data={this.state.proxyJsonWeeklyCheckList}
                                  name='StorewiseHandovers'
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  title='Handovers'
                                  storeDashboard={true}
                                  data={this.state.proxyJsonMonthlyCheckList}
                                  name='HandoversMonthlyBSU'
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div>

                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.activeTab === 3 ? (
                          <div
                            className={
                              this.state.activeTab === 3
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_4'
                          >
                            {/* <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  title='Evacuations'
                                  storeDashboard={true}
                                  data={this.state.proxyjson}
                                  name='StorewiseEvacuations'
                                  storeid={this.state.storeid}
                                  dataClick={'Noncoformities'}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8 close'>
                                <DataTables
                                  title='Nonconformities'
                                  storeDashboard={true}
                                  data={this.state.proxyjson}
                                  name='StorewiseNonconformities'
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div> */}
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  title='Nonconformities'
                                  storeDashboard={true}
                                  data={this.state.proxyJsonWeeklyCheckList}
                                  name='StorewiseNonconformities'
                                  dataClick={'Noncoformities'}
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div>
                            <br />
                            <div className='row'>
                              <div className='col-md-12'>
                                <StackedBar
                                  mainTitle='Points Open and Points Closed'
                                  title={['Points Open', 'Points Closed']}
                                  label={this.state.proxyjson.stores}
                                  data={[
                                    this.state.proxyJsonWeeklyCheckList
                                      .totalOpenCount,
                                    this.state.proxyJsonWeeklyCheckList
                                      .totalCloseCount,
                                  ]}
                                />
                              </div>
                            </div>

                            <br />
                            <div className='row'>
                              <div className='col-md-12'>
                                {this.state.graph ? (
                                  <PolarChart
                                    title='Non Confirm Points'
                                    name={true}
                                    labels={this.state.proxyJsonWeeklyCheckList.dhead.slice(
                                      1
                                    )}
                                    data={
                                      this.state.proxyJsonWeeklyCheckList
                                        .graphData[currentMonth - 1]
                                    }
                                  />
                                ) : null}
                              </div>
                            </div>
                            <br />
                            <br />

                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.activeTab === 4 ? (
                          <div
                            className={
                              this.state.activeTab === 4
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_5'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  storeDashboard={true}
                                  data={this.state.proxyjson4}
                                  storeid={this.state.storeid}
                                  //dataClick={'safetyRegister'}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>

                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.activeTab === 5 ? (
                          <div
                            className={
                              this.state.activeTab === 5
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_6'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  storeDashboard={true}
                                  data={this.state.proxyjson5}
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>

                              <div className='col-md-2'></div>
                            </div>

                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        <div className='tab-pane' id='tab_7'>
                          <br />
                          <br />
                        </div>
                        {/* /.tab-pane */}
                        {this.state.activeTab === 1 ? (
                          <div
                            className={
                              this.state.activeTab === 1
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_2'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  title='Evacuations'
                                  storeDashboard={true}
                                  data={this.state.proxyjson}
                                  name='StorewiseEvacuations'
                                  storeid={this.state.storeid}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8 close'>
                                {loading ? (
                                  <Spinner />
                                ) : (
                                  <DataTables
                                    title='incidents'
                                    count={false}
                                    storeDashboard={true}
                                    data={this.state.proxyjson}
                                    name='StorewiseIncidents'
                                    storeid={this.state.storeid}
                                    multisearch=''
                                    year={currentyear}
                                    month={currentMonth}
                                    loader={() => this.handleLoader()}
                                  />
                                )}
                              </div>
                              <div className='col-md-2'></div>
                            </div>

                            <br />
                            <br />
                            <div className='row'>
                              <div className='col-md-6'>
                                <BarChart
                                  mainTitle='No of Incidents'
                                  title={[
                                    'No of Incidents by Month',
                                    'No of Incidents YTD',
                                  ]}
                                  label={this.state.alerts}
                                  data={[
                                    this.state.alertno,
                                    this.state.ytdCount,
                                  ]}
                                />
                              </div>
                              <div className='col-md-6'>
                                <DoughNut
                                  title='Montly Incidents'
                                  name={true}
                                  labels={this.state.alerts}
                                  data={this.state.alertno}
                                />
                              </div>
                            </div>

                            <br />
                            <div className='spacer-mini'></div>
                            <div className='row'>
                              <div className='col-md-6'>
                                <PolarChart
                                  title='No of Incidents YTD'
                                  name={true}
                                  labels={this.state.alerts}
                                  data={this.state.ytdCount}
                                />
                              </div>
                              <div className='col-md-6'></div>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {/* /.tab-pane */}

                        {/* /.tab-pane */}
                      </div>
                      {/* /.tab-content */}
                    </div>
                    {/* nav-tabs-custom */}
                  </div>
                </div>
              )}
              {/* /.row */}
              {/* END CUSTOM TABS */}
            </section>
          </div>
          <Footer />
        </div>
      </>
    );
  }
}

export default StoreDashboardRetail;
